import { useEffect } from 'react';

/**
 * Simple SEO hook — sets document.title and <meta name="description">, canonical, and Open Graph tags per page.
 * Avoids adding react-helmet dependency; safe for CSR since Google now renders JS.
 */
export default function useSeo({ title, description, path = '', image, jsonLd }) {
  const ldString = jsonLd ? JSON.stringify(jsonLd) : null;
  useEffect(() => {
    if (title) document.title = title;

    let ld = document.head.querySelector('script[data-seo-jsonld]');
    if (ldString) {
      if (!ld) {
        ld = document.createElement('script');
        ld.type = 'application/ld+json';
        ld.setAttribute('data-seo-jsonld', '');
        document.head.appendChild(ld);
      }
      ld.textContent = ldString;
    } else if (ld) {
      ld.remove();
    }

    const setMeta = (attr, key, value) => {
      if (!value) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', value);
    };

    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    if (image) setMeta('property', 'og:image', image);

    const base = 'https://beechwooddentalstudio.ca';
    const url = `${base}${path || ''}`;
    setMeta('property', 'og:url', url);
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    if (image) setMeta('name', 'twitter:image', image);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);
  }, [title, description, path, image, ldString]);
}
